import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const UserStats = ({ users, surveyors, admins }) => {
  return (
    <>
      <Row>
      <Col lg="4" className=" mb-3">
          <Card className="card-main media userCard h-100">
            <div className="media-body">
              <h3>Total Users</h3>
              <div className="count">{users}</div>
            </div>
          </Card>
        </Col>
        <Col lg="4" className=" mb-3">
          <Card className="card-main media userCard bg-red h-100">
            <div className="media-body">
              <h3>Surveyors</h3>
              <div className="count">{surveyors}</div>
            </div>
          </Card>
        </Col>
        <Col lg="4" className=" mb-3">
          <Card className="card-main media userCard  bg-indigo h-100">
            <div className="media-body">
              <h3>Admins</h3>
              <div className="count">{admins > 0 ? admins : 0}</div>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default UserStats;
